import { render, staticRenderFns } from "./Pricelist.vue?vue&type=template&id=0d5d28fa&"
import script from "./Pricelist.vue?vue&type=script&lang=js&"
export * from "./Pricelist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports